import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { FormlyFieldConfig } from "@ngx-formly/core";

export function taskFallbackFields(): FormlyFieldConfig[] {
    return [
        {
            fieldGroupClassName: 'flex flex-wrap',
            props: {
            },
            fieldGroup: [
                {
                    className: "w-full",
                    fieldGroupClassName: "flex flex-wrap",
                    fieldGroup: [
                        {
                            key: 'title',
                            className: "w-full md:w-1/2",
                            type: 'input',
                            props: {
                                label: _('entities.Task.title'),
                                translate: true,
                                focusOnNew: true,
                                required: true,
                                attributes: {
                                    'data-testid': 'formly-task-title'
                                }
                            },
                        },
                        {
                            key: 'status',
                            className: "w-full md:w-1/4",
                            type: 'formly-generic-enum-drop-down',
                            props: {
                                label: _('entities.Task.status'),
                                translate: true,
                                attributes: {
                                    'data-testid': 'formly-task-status',
                                    enumName: "TaskStatus"
                                }
                            },
                        },
                        {
                            key: 'priority',
                            className: "w-full md:w-1/4",
                            type: 'formly-generic-enum-drop-down',
                            props: {
                                label: _('entities.Task.priority'),
                                translate: true,
                                attributes: {
                                    'data-testid': 'formly-task-priority',
                                    enumName: "TaskPriority"
                                }
                            },
                        },
                        {
                            key: 'description',
                            className: "w-full",
                            type: 'textarea',
                            props: {
                                label: _('entities.Task.description'),
                                translate: true,
                                rows: 2,
                                attributes: {
                                    'data-testid': 'formly-task-description'
                                }
                            },
                        },
                        {
                            key: 'assignedEmployee',
                            className: "w-full md:w-1/2",
                            type: 'formly-employee-drop-down',
                            props: {
                                label: _('entities.Task.assignedEmployee'),
                                translate: true,
                                autoLoad: false
                            },
                        },
                        {
                            key: 'dueDate',
                            className: "w-full md:w-1/2",
                            type: 'datepicker',
                            props: {
                                label: _('entities.Task.dueDate'),
                                translate: true,
                                attributes: {
                                    'data-testid': 'formly-task-due-date'
                                }
                            },
                        },
                        {
                            key: 'notes',
                            className: "w-full",
                            type: 'textarea',
                            props: {
                                label: _('entities.Task.notes'),
                                translate: true,
                                rows: 3,
                                attributes: {
                                    'data-testid': 'formly-task-notes'
                                }
                            },
                        },
                    ]
                },
            ]
        },
    ]
} 